import { render, staticRenderFns } from "./eventolaborantes.vue?vue&type=template&id=08b7a43b&scoped=true"
import script from "./eventolaborantes.vue?vue&type=script&lang=js"
export * from "./eventolaborantes.vue?vue&type=script&lang=js"
import style0 from "./eventolaborantes.vue?vue&type=style&index=0&id=08b7a43b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7a43b",
  null
  
)

export default component.exports